import { Injectable } from '@angular/core';
import { Order } from '@compumark/order-management-client';
import { BehaviorSubject } from 'rxjs';

export interface Update {
  id?: string;
  currentAction?: string;
  orderAfterPendingUpdate?: Order;
}
@Injectable({
  providedIn: 'root',
})
export class UpdateOrderService {
  private updateSubject = new BehaviorSubject<Update>({});
  pendingUpdate$ = this.updateSubject.asObservable();

  constructor() {}
  notifyUpdate = (orderId: string, action: string, order?: Order) => {
    if (order !== undefined) {
      this.updateSubject.next({
        id: orderId,
        currentAction: action,
        orderAfterPendingUpdate: order,
      });
    } else {
      this.updateSubject.next({ id: orderId, currentAction: action });
    }
  };
}
